<template>
    <div class="discount-container">
        <input
            readonly="readonly"
            type="text"
            v-on:focus="$event.target.select()" 
            ref="code" 
            :value="code"
        >
        <div class="text-right">
            <span class="btn btn-info" @click="copy()">{{ text }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['code'],
        data() {
            return {
                text: 'Copy Code'
            }
        },
        mounted() {

        },
        methods: {
            copy() {
                this.$refs.code.focus();
                document.execCommand('copy');
                this.text = 'Copied!';
                setTimeout(() => this.text = 'Copy Code', 1500);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .discount-container {
        border-style: dashed;
        background-color: #FDF3CD;
        border-color: #38B577;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        padding: 10px;
        margin-bottom: 10px;
        input {
            background: inherit;
            border: 0;
            text-align: center;
            &:focus-visible {
                outline: 0;
                border: 0;
            }
        }
    }
</style>